<template>
  <div class="underlay bg-gradient-day">
    <div class="underlay clouds">
      <div class="underlay underlay--animated" />
    </div>
    <div class="underlay mountains2">
      <div class="underlay underlay--animated" />
    </div>
    <div class="underlay mountains">
      <div class="underlay underlay--animated" />
    </div>
    <div class="underlay mist">
      <div class="underlay underlay--animated" />
    </div>
    <div class="underlay hills">
      <div class="underlay underlay--animated" />
    </div>
    <div class="underlay fields">
      <div class="underlay underlay--animated" />
    </div>
    <!-- character -->
    <div class="bgdragon">
      <img alt="Dragon Rainbow" src="@/assets/images/people/sprinkles/rainbow.png" class="bgdragon__rainbow">
      <div class="bgdragon__inner">
        <div class="bgdragon__image">
          <img alt="Character" src="@/assets/images/people/sprinkles/left/0.png">
          <img alt="Character" src="@/assets/images/people/sprinkles/left/1.png">
          <img alt="Character" src="@/assets/images/people/sprinkles/left/2.png">
          <img alt="Character" src="@/assets/images/people/sprinkles/left/3.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Background'
}
</script>

<style scoped lang="scss">
.bg-gradient-day {
  overflow: hidden;
}
.underlay--animated {
  transform: translate3d(0, 0, 0);
  transition: transform 2s ease;

  .clouds & {
    left: -849px;
    width: calc(100% + 849px);
    background-image: url('../assets/images/backgrounds/clouds.png');
    background-repeat: repeat-x;
    background-size: auto 225px;
    height: 225px;
    bottom: 300px;
    top: auto;
    animation: clouds 150s linear infinite;
  }
  .mountains2 & {
    left: -10px;
    width: calc(100% + 20px);
    background-image: url('../assets/images/backgrounds/mountains2.png');
    background-repeat: repeat-x;
    background-position: 0 0;
    background-size: auto 165px;
    height: 165px;
    bottom: 260px;
    top: auto;

    .bg-gradient-day[data-scene="friends"] & {
      transform: translate3d(10px, 0, 0);
    }
    .bg-gradient-day[data-scene="village"] & {
      transform: translate3d(0, 0, 0);
    }
    .bg-gradient-day[data-scene="world"] & {
      transform: translate3d(-10px, 0, 0);
    }
  }
  .mountains & {
    left: -20px;
    width: calc(100% + 40px);
    background-image: url('../assets/images/backgrounds/mountains.png');
    background-repeat: repeat-x;
    background-position: 0 0;
    background-size: auto 238px;
    height: 238px;
    bottom: 200px;
    top: auto;

    .bg-gradient-day[data-scene="friends"] & {
      transform: translate3d(20px, 0, 0);
    }
    .bg-gradient-day[data-scene="village"] & {
      transform: translate3d(0, 0, 0);
    }
    .bg-gradient-day[data-scene="world"] & {
      transform: translate3d(-20px, 0, 0);
    }
  }
  .mist & {
    background-image: url('../assets/images/backgrounds/mist.png');
    background-repeat: repeat-x;
    background-size: auto 164px;
    background-position: 0 0;
    height: 164px;
    bottom: 230px;
    top: auto;
  }
  .hills & {
    left: -40px;
    width: calc(100% + 80px);
    background-image: url('../assets/images/backgrounds/hills.png');
    background-repeat: repeat-x;
    background-position: 0 0;
    background-size: auto 487px;
    height: 487px;
    bottom: -80px;
    top: auto;

    .bg-gradient-day[data-scene="friends"] & {
      transform: translate3d(40px, 0, 0);
    }
    .bg-gradient-day[data-scene="village"] & {
      transform: translate3d(0, 0, 0);
    }
    .bg-gradient-day[data-scene="world"] & {
      transform: translate3d(-40px, 0, 0);
    }
  }
  .fields & {
    left: -80px;
    width: calc(100% + 160px);
    background-image: url('../assets/images/backgrounds/fields.png');
    background-repeat: repeat-x;
    background-position: 0 0;
    background-size: auto 368px;
    height: 368px;
    bottom: -25px;
    top: auto;

    .bg-gradient-day[data-scene="friends"] & {
      transform: translate3d(80px, 0, 0);
    }
    .bg-gradient-day[data-scene="village"] & {
      transform: translate3d(0, 0, 0);
    }
    .bg-gradient-day[data-scene="world"] & {
      transform: translate3d(-80px, 0, 0);
    }
  }
}
@keyframes clouds {
  0% {
    transform: translate3d(849px, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/landing/mixins.scss';

.bgdragon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  pointer-events: none;
  opacity: 0;
  transform: translate3d(-50vw, 50vh, 0);
  transition: opacity 1s ease, transform 1s ease;

  @include breakpoint(md) {
    transform: translate3d(-20vw, 60vh, 0);
  }
}
.bgdragon__rainbow {
  position: absolute;
  z-index: 0;
  bottom: 50%;
  left: 50%;
  width: auto;
  height: auto;
  min-width: 100vw;
  min-height: 100vh;

  @include breakpoint(md) {
    width: 100vw;
    height: 100vh;
  }
}
.bgdragon__inner {
  position: relative;
  z-index: 1;
  width: 184px;
  overflow: hidden;
}
.bgdragon__image {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  transform: translate3d(0, 0, 0);
  // animation: dragon-animate .8s steps(3) infinite 1s;

  img {
    display: block;
    width: 184px;
    height: auto;
  }
}
</style>
